<template>
  <el-table v-if="cutView=='export'" stripe border style="width: 100%" height="100%" size="mini"
    :data="tableData" :row-class-name="tableRowClassName">
    <el-table-column type="index" align="center"
      :width="pagination.endIndex >= 1000 ? 80 : 50"
      :index="pagination.beginIndex"
    ></el-table-column>
    <el-table-column label="工单号" min-width="110px" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.aufnr ? scope.row.aufnr : '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="工序" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.vornr ? scope.row.vornr : '-'}}</span>
      </template>
    </el-table-column>
    <el-table-column label="工作中心" min-width="100px" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.ktext" :content="scope.row.ktext" class="item" effect="dark" placement="top" :open-delay="300">
          <span>
            {{scope.row.arbpl ? scope.row.arbpl : '-'}}
          </span>
        </el-tooltip>
        <span v-else>{{scope.row.arbpl ? scope.row.arbpl : '-'}}</span>
      </template>
    </el-table-column>
    <el-table-column label="报工标识" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.steus ? scope.row.steus : '-'}}</span>
      </template>
    </el-table-column>
    <el-table-column label="生产人数" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.mgvrg ? scope.row.mgvrg : '-'}}</span>
      </template>
    </el-table-column>
    <el-table-column label="报工数量" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.lmnga ? scope.row.lmnga : '-'}}</span>
      </template>
    </el-table-column>
    <el-table-column label="直接人工" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.vgw01}}{{ scope.row.vge01 }}</span>
      </template>
    </el-table-column>
    <el-table-column label="间接人工" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.vgw02}}{{ scope.row.vge02 }}</span>
      </template>
    </el-table-column>
    <el-table-column label="能源折旧" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.vgw03}}{{ scope.row.vge03 }}</span>
      </template>
    </el-table-column>
    <el-table-column label="租金折旧" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.vgw04}}{{ scope.row.vge04 }}</span>
      </template>
    </el-table-column>
    <el-table-column label="间接/模具" min-width="100px" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.vgw04}}{{ scope.row.vge04 }}</span>
      </template>
    </el-table-column>
    <el-table-column label="其他制费" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.vgw06}}{{ scope.row.vge06 }}</span>
      </template>
    </el-table-column>
    <el-table-column label="异常工时" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.reserve1 ? scope.row.reserve1 : '-'}}</span>
      </template>
    </el-table-column>
      <el-table-column label="报工人" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="textOverflow">{{ scope.row.user.name }}({{scope.row.user.employeeNum}})</span>
        </template>
      </el-table-column>
      <el-table-column label="报工时间" min-width="120px" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="textOverflow">{{ scope.row.createDateTime }}</span>
        </template>
      </el-table-column>
  </el-table>
</template>
<script>
import {
  apiSapReportedExport
} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    cutView:null,
    searchConditionForm:{type: Object},
    pagination:{}
  },
  computed: {
  },
  components: {
  },
  created() {
  },
  data() {
    return {
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      tableData:null,
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    tableRowClassName({row}) {
      if (row.steus && row.steus=='R') {
        return 'warning-row';
      }
      return '';
    },
    clickAllowSkip(row) {
      this.$parent.cutDetail = "shipmentDetail";
      this.$parent.nowRowData = row;
      this.$parent.tabPaneValue = row.id;
      let tabPaneIds = this.$parent.tabPaneList2.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.$parent.tabPaneList2.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.$parent.tabPaneList2.push(row);
      }
    },
    async onSearch(callback) {
      this.tableData = [];
      const res = await apiSapReportedExport({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      });
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;        
        if (callback) {callback();}
      }
    }
  }
};
</script>

<style>
  .el-table .warning-row {
    color: #F56C6C;
  }
</style>